import { Link, useLocation } from 'react-router-dom';
import { Empty } from '../components/Empty';
import { Ic } from '../components/Ic';

export function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="view-pad">
      <Empty icon={Ic.search} title="Page not found" detail={pathname} />
      <div style={{ textAlign: 'center' }}>
        <Link className="btn sm" to="/">
          Back to overview <Ic.arrowRight className="ico" />
        </Link>
      </div>
    </div>
  );
}
